import React, { useEffect, useState } from "react";


export default function SplashLoader({ onFinish }) {
    const [fadingOut, setFadingOut] = useState(false);

    useEffect(() => {
        // Prevent background scrolling while splash is active
        document.body.classList.add("body-lock");

        // Show for 4.5 seconds, then start fade out for 0.5s
        const timer = setTimeout(() => {
            setFadingOut(true);
            setTimeout(() => {
                document.body.classList.remove("body-lock");
                onFinish();
            }, 500);
        }, 4500);

        return () => {
            clearTimeout(timer);
            document.body.classList.remove("body-lock");
        };
    }, [onFinish]);

    return (
        <div
            className={`fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white transition-opacity duration-500 ease-in-out ${fadingOut ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}
        >
            <div className="relative flex flex-col items-center">
                {/* Logo Container with Pulse and Scale Animation */}
                <div className="w-32 h-32 mb-8 animate-pulse">
                    <img
                        src="/static/images/temb_music_logo_transparent.png"
                        alt="Temidayo Balogun"
                        className="w-full h-full object-contain scale-[2.5]"
                    />
                </div>

                {/* Loading Bars */}
                <div className="flex gap-1.5 h-8">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div
                            key={i}
                            className="w-1 bg-jazz-brown rounded-full animate-bounce"
                            style={{ animationDelay: `${i * 0.1}s`, animationDuration: '1s' }}
                        />
                    ))}
                </div>

                {/* Text Fade In */}
                <div className="mt-8 overflow-hidden">
                    <h1
                        className="text-black text-xl tracking-[0.3em] font-light uppercase animate-slideInUp"
                        style={{ fontFamily: 'Montserrat, sans-serif' }}
                    >
                        Temidayo Balogun
                    </h1>
                </div>
            </div>

            <style jsx>{`
        @keyframes slideInUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideInUp {
          animation: slideInUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
        </div>
    );
}
